import React from "react";
import style from "./style.module.css";
import boundClasses from "classnames/bind";
import EyeGroup from "../../images/eye-group.svg";
import { ParagraphGroup } from "../paragraph-group";

export interface InsightProps {
    insight: InsightAnatomy;
    index: number;
}

export interface InsightAnatomy {
    title?: string;
    body: string;
    explanation?: string;
}

export function Insight(props: InsightProps) {
    const insightClass = boundClasses(
        { [style.insight]: true },
        { [style.goofy]: props.index % 2 === 1 }
    )
    return (
        <section className={style.insightWrapper}>
            <section className={insightClass}>
                <img
                    className={style.icon}
                    src={EyeGroup}
                    alt="A group of eyes that look like eyeballs"
                />
                <section className={style.text}>
                    <h2 className={style.title}>{props.insight.title}</h2>
                    <p className={style.body}>{props.insight.body}</p>
                </section>
            </section>
            {props.insight.explanation ?
                <ParagraphGroup
                    body={[props.insight.explanation]}
                    groupStyle={style.explanation}
                />
                : null}
        </section>
    );
}